
namespace GeniuzPOS.PosShift {

    @Serenity.Decorators.registerClass()
    export class PsVatRefundRateDialog extends Serenity.EntityDialog<PsVatRefundRateRow, any> {
        protected getFormKey() { return PsVatRefundRateForm.formKey; }
        protected getIdProperty() { return PsVatRefundRateRow.idProperty; }
        protected getLocalTextPrefix() { return PsVatRefundRateRow.localTextPrefix; }
        protected getNameProperty() { return PsVatRefundRateRow.nameProperty; }
        protected getService() { return PsVatRefundRateService.baseUrl; }
        protected getDeletePermission() { return PsVatRefundRateRow.deletePermission; }
        protected getInsertPermission() { return PsVatRefundRateRow.insertPermission; }
        protected getUpdatePermission() { return PsVatRefundRateRow.updatePermission; }

        protected form = new PsVatRefundRateForm(this.idPrefix);

        constructor() {
            super();

           


            this.form.RefundFg.change(e => {
                let x = this.form.RefundFg.value
                if (x == "1") {    
                      
                        this.form.PurchaseTo.value = null
                        Serenity.EditorUtils.setReadOnly(this.form.PurchaseTo, true);                
                }else{
                    Serenity.EditorUtils.setReadOnly(this.form.PurchaseTo, false);  
                }
            });


        }

        protected afterLoadEntity(): void {
            if(!this.isNew()){
                let x = this.form.RefundFg.value
                if (x == "1") {    
                      
                        //this.form.PurchaseTo.value = null
                    Serenity.EditorUtils.setReadOnly(this.form.PurchaseTo, true);                
                }else{
                    Serenity.EditorUtils.setReadOnly(this.form.PurchaseTo, false);  
                }
            }
        }


    }
}